const FileUploadActions = {
    Upload: "FILEUPLOAD.UPLOAD",
    Uploaded: "FILEUPLOAD.UPLOADED",
    UploadErrored: "FILEUPLOAD.UPLOADERRORED"
};

module.exports = FileUploadActions;


// WEBPACK FOOTER //
// ./src/actions/FileUploadActions.js